import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const PipelineConfigIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/pipeline-config'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_pipeline_config', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_pipeline_config',
          component: PipelineConfigIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
